import { decamelizeKeys } from 'redux/helpers/utils';

// The backend names each attribute as the service expects it, but responses arrive camelized
const integrationAttributes = (integrations, integration) => decamelizeKeys(integrations?.[integration] ?? {});

export default integrationAttributes;
